module.exports = __webpack_public_path__ + "b12c9a8.woff2";